import './CSS/AboutMePic.css';
function AboutMe(props) {
    return (
        <img id="queen" className="queen" src={props.photoOfMe} alt="queen"/>             
    );
  }
  
  export default AboutMe;
  